"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadDocument = uploadDocument;
const axios_1 = require("./clients/axios");
/**
 * Uploads a file through the backend to S3.
 */
async function uploadDocument(file, purpose = 'user-document', onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', purpose);
    const response = await axios_1.client.post('/0/media/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent => {
            if (onUploadProgress && progressEvent.total) {
                onUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            }
        },
    });
    return response.data;
}
